/**
 * The term the topbar search handed to this page.
 *
 * The topbar can put a name in front of a list page but cannot deep-link
 * to a record, because records have no detail route. So it navigates to
 * the list with `?search=<term>` and the list opens already filtered to
 * it — the click lands on the row you picked, not on page one of
 * everything.
 *
 * Read once, as the initial value of the page's own search state: after
 * that the page owns the term and the user can clear it like any other.
 */
export const initialSearchFromUrl = () => {
  if (typeof window === 'undefined') return '';
  return new URLSearchParams(window.location.search).get('search') || '';
};
